<!-- <template>
  <div class="v-select">
    <input @click="showInputAndOptions" :value="selectedOption ? selectedOption[labelColumn] : search"
      class="form-select" readonly />
    <div v-if="showInputField && showOptions" class="v-select-options rounded-bottom w-100 shadow p-2">
     
      <div class="d-flex form-control m-0 p-0">
        <input v-if="showInputField" type="text" class="form-control border-0 outline-none" v-model="search" @input="$emit('input', search)"
          @keydown.down="navigateDown" @keydown.up="navigateUp" @keydown.enter="selectOption" @blur="closeDropdown"
          :placeholder="placeholder" ref="searchInput" />
        <button class="btn ">
          <i class="bi bi-trash3-fill"></i>
        </button>
      </div>
      
      <div v-if="filteredOptions.length === 0" class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="loader"></div>
      </div>
      <ul v-if="showOptions" class="border-0 w-100 list-unstyled">
        <li v-for="(option, index) in filteredOptions" :key="index" @click="selectOption(option)"
          :class="{ 'v-select-option-selected': isSelected(option) }" class="list-unstyled border-top py-1">
          {{ option[labelColumn] }} 
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number, null], // Allow null as well
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    // New props for column names
    labelColumn: {
      type: String,
      required: true,
    },
    valueColumn: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      selectedIndex: -1,
      showOptions: false,
      showInputField: false,
      selectedOption: null,
    };
  },
  watch: {
    value(newValue) {
      if (newValue === null) {
        this.selectedOption = null;
        this.search = '';
      } else {
        const matchedOption = this.options.find(option => option[this.valueColumn] === newValue);
        if (matchedOption) {
          this.selectedOption = matchedOption;
          this.search = matchedOption[this.labelColumn];
        }
      }
    },
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) => {
        const label = option[this.labelColumn];
        return label && label.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    showInputAndOptions() {
      this.showInputField = !this.showInputField;
      this.showOptions = !this.showOptions;
      this.$nextTick(() => {
        if (this.showInputField) {
          this.$refs.searchInput.focus(); // Focus the input element
        }
      });
    },
    async closeDropdown() {
      await setTimeout(() => {
        this.showOptions = false;
        this.showInputField = false;
      }, 1000);
    },
    navigateDown() {
      if (this.selectedIndex < this.filteredOptions.length - 1) {
        this.selectedIndex++;
        this.search = this.filteredOptions[this.selectedIndex][this.labelColumn];
      }
    },
    navigateUp() {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.search = this.filteredOptions[this.selectedIndex][this.labelColumn];
      }
    },
    async selectOption(option) {
      await this.$emit('input', option[this.valueColumn]); // Emit the selected option's value for v-model
      this.search = option[this.labelColumn];
      this.showOptions = false;
      this.showInputField = false;
      this.selectedOption = option; // Set the selected option
    },
    isSelected(option) {
      return option[this.valueColumn] === this.value;
    },
  },
};
</script>

<style scoped>
/* Your custom styles for the v-select component */
.v-select {
  position: relative;
}

.v-select-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  position: fixed;
  top: 100%;
}

.v-select-options {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  padding: 10px;
  z-index: 1;
  height: 213px; 
  max-height: 270px;
  overflow-y: auto !important;
}
.v-select-options ul{
    list-style: none;
    widows: 100% !important;
}

.v-select-option {
  padding: 10px;
  cursor: pointer;
}

.v-select-option-selected {
  background-color: #f0f0f0;
}

/* HTML: <div class="loader"></div> */
.loader {
  --d:22px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  color: #25b09b;
  box-shadow: 
    calc(1*var(--d))      calc(0*var(--d))     0 0,
    calc(0.707*var(--d))  calc(0.707*var(--d)) 0 1px,
    calc(0*var(--d))      calc(1*var(--d))     0 2px,
    calc(-0.707*var(--d)) calc(0.707*var(--d)) 0 3px,
    calc(-1*var(--d))     calc(0*var(--d))     0 4px,
    calc(-0.707*var(--d)) calc(-0.707*var(--d))0 5px,
    calc(0*var(--d))      calc(-1*var(--d))    0 6px;
  animation: l27 1s infinite steps(8);
}
@keyframes l27 {
  100% {transform: rotate(1turn)}
}
</style> -->

<!-- <template>
  <div class="v-select">
    <input @click="showInputAndOptions" :value="selectedOption ? selectedOption[labelColumn] : search"
      class="form-select" readonly />
    <div v-if="showInputField && showOptions" class="v-select-options rounded-bottom w-100 shadow p-2">
      <div class="d-flex form-control m-0 p-0">
        <input v-if="showInputField" type="text" class="form-control border-0 outline-none" v-model="search"
          @input="$emit('input', search)" @keydown.down="navigateDown" @keydown.up="navigateUp"
          @keydown.enter="selectOption" @blur="closeDropdown" :placeholder="placeholder" ref="searchInput" />
        <button class="btn" @click="clearSearch">
          <i class="bi bi-trash3-fill"></i>
        </button>
      </div>
      <div v-if="filteredOptions.length === 0" class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="loader"></div>
      </div>
      <ul v-if="showOptions" class="border-0 w-100 list-unstyled">
        <li v-for="(option, index) in filteredOptions" :key="index" @click="selectOption(option)"
          :class="{ 'v-select-option-selected': isSelected(option) }" class="list-unstyled border-top py-1">
          {{ option[labelColumn] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    labelColumn: {
      type: String,
      required: true,
    },
    valueColumn: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      selectedIndex: -1,
      showOptions: false,
      showInputField: false,
      selectedOption: null,
    };
  },
  watch: {
    value(newValue) {
      if (newValue === null) {
        this.selectedOption = null;
        this.search = '';
      } else {
        const matchedOption = this.options.find(option => option[this.valueColumn] === newValue);
        if (matchedOption) {
          this.selectedOption = matchedOption;
          this.search = matchedOption[this.labelColumn];
        }
      }
    },
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) => {
        const label = option[this.labelColumn];
        return label && label.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    showInputAndOptions() {
      this.showInputField = !this.showInputField;
      this.showOptions = !this.showOptions;
      this.$nextTick(() => {
        if (this.showInputField) {
          this.$refs.searchInput.focus();
        }
      });
    },
    async closeDropdown() {
      await setTimeout(() => {
        this.showOptions = false;
        this.showInputField = false;
      }, 1000);
    },
    navigateDown() {
      if (this.selectedIndex < this.filteredOptions.length - 1) {
        this.selectedIndex++;
        this.search = this.filteredOptions[this.selectedIndex][this.labelColumn];
      }
    },
    navigateUp() {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.search = this.filteredOptions[this.selectedIndex][this.labelColumn];
      }
    },
    async selectOption(option) {
      await this.$emit('input', option[this.valueColumn]);
      this.search = option[this.labelColumn];
      this.showOptions = false;
      this.showInputField = false;
      this.selectedOption = option;
    },
    isSelected(option) {
      return option[this.valueColumn] === this.value;
    },
    clearSearch() {
      this.search = '';
      this.selectedOption = null;
      // this.$emit('input', null);
    },
  },
};
</script>

<style scoped>
.v-select {
  position: relative;
}

.v-select-options {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  padding: 10px;
  z-index: 1;
  height: 213px;
  max-height: 270px;
  overflow-y: auto !important;
}

.v-select-option-selected {
  background-color: #f0f0f0;
}

.loader {
  --d: 22px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  color: #25b09b;
  box-shadow:
    calc(1*var(--d)) calc(0*var(--d)) 0 0,
    calc(0.707*var(--d)) calc(0.707*var(--d)) 0 1px,
    calc(0*var(--d)) calc(1*var(--d)) 0 2px,
    calc(-0.707*var(--d)) calc(0.707*var(--d)) 0 3px,
    calc(-1*var(--d)) calc(0*var(--d)) 0 4px,
    calc(-0.707*var(--d)) calc(-0.707*var(--d)) 0 5px,
    calc(0*var(--d)) calc(-1*var(--d)) 0 6px;
  animation: l27 1s infinite steps(8);
}

@keyframes l27 {
  100% {
    transform: rotate(1turn)
  }
}
</style> -->
<template>
  <div class="v-select" ref="selectRoot">
    <!-- INPUT PRINCIPAL VISIBLE -->
    <div class="v-select-input-wrapper">
      <input
        type="text"
        class="form-select"
        :class="{ 'has-selected-image': selectedOption && selectedOption.image }"
        :placeholder="placeholder"
        :value="selectedOption ? selectedOption[labelColumn] : ''"
        readonly
        @click="toggleDropdown"
      />
      <img
        v-if="selectedOption && selectedOption.image"
        class="selected-option-image"
        :src="selectedOption.image"
        alt=""
        @error="hideImage"
      />
      <i class="bi bi-chevron-down select-arrow"></i>
    </div>

    <!-- MENU -->
    <transition name="fade-slide">
      <div
        v-if="showOptions"
        class="v-select-dropdown shadow rounded-bottom"
        ref="dropdown"
      >
        <!-- SEARCH BAR -->
        <div class="search-box d-flex align-items-center p-1">
          <input
            type="text"
            class="form-control border-0"
            v-model="search"
            ref="searchInput"
            @input="filter"
            @keydown.down.prevent="navigateDown"
            @keydown.up.prevent="navigateUp"
            @keydown.enter.prevent="selectHighlighted"
            placeholder="Rechercher..."
          />
          <button class="btn btn-light" @click="clearSearch">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- OPTIONS -->
        <ul class="option-list list-unstyled m-0 p-0">
          <li
            v-for="(option, index) in filtered"
            :key="index"
            class="option-item p-2 border-bottom"
            :class="[
              isSelected(option) ? 'selected-option' : '',
              index === highlightedIndex ? 'highlighted' : '',
              rowClass ? rowClass(option) : ''
            ]"
            @click="select(option)"
          >
            <slot name="option" :option="option">
              <div class="option-content">
                <img
                  v-if="option.image"
                  class="option-image"
                  :src="option.image"
                  alt=""
                  @error="hideImage"
                />
                <span class="option-label">{{ option[labelColumn] }}</span>
              </div>
            </slot>
          </li>

          <li v-if="filtered.length === 0" class="loader-container p-3 text-center">
            <div class="loader"></div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    value: { type: [String, Number, null], default: null },
    labelColumn: { type: String, required: true },
    valueColumn: { type: String, required: true },
    placeholder: { type: String, default: "Select..." },

    // ✅ function(row) → return class string
    rowClass: {
      type: Function,
      default: null
    },
  },

  data() {
    return {
      search: "",
      filtered: [],
      showOptions: false,
      selectedOption: null,
      highlightedIndex: -1,
    };
  },

  mounted() {
    this.filtered = this.options;
    this.syncValue(this.value);

    // ✅ Click outside
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  watch: {
    value(newVal) {
      this.syncValue(newVal);
    },
    options() {
      this.filtered = this.options;
    },
  },

  methods: {
    handleClickOutside(e) {
      if (!this.$refs.selectRoot.contains(e.target)) {
        this.closeDropdown();
      }
    },

    toggleDropdown() {
      this.showOptions = !this.showOptions;

      var self = this;
      this.$nextTick(function () {
        if (self.showOptions && self.$refs.searchInput) {
          self.$refs.searchInput.focus();
        }
      });
    },

    closeDropdown() {
      this.showOptions = false;
      this.highlightedIndex = -1;
    },

    filter() {
      var s = this.search.toLowerCase();

      this.filtered = this.options.filter(function (opt) {
        var label = opt[this.labelColumn];
        if (!label) return false;
        return label.toLowerCase().includes(s);
      }.bind(this));

      this.highlightedIndex = 0;
    },

    clearSearch() {
      this.search = "";
      this.filtered = this.options;
      this.highlightedIndex = -1;
    },

    select(option) {
      this.selectedOption = option;
      this.search = option[this.labelColumn];
      this.showOptions = false;
      this.$emit("input", option[this.valueColumn]);
    },

    selectHighlighted() {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filtered.length) {
        this.select(this.filtered[this.highlightedIndex]);
      }
    },

    navigateDown() {
      if (this.highlightedIndex < this.filtered.length - 1) {
        this.highlightedIndex++;
        this.scrollToHighlighted();
      }
    },

    navigateUp() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
        this.scrollToHighlighted();
      }
    },

    scrollToHighlighted() {
      var dropdown = this.$refs.dropdown;
      if (!dropdown) return;

      var option = dropdown.querySelectorAll(".option-item")[this.highlightedIndex];
      if (!option) return;

      var top = option.offsetTop;
      var bottom = top + option.offsetHeight;

      if (top < dropdown.scrollTop) {
        dropdown.scrollTop = top;
      } else if (bottom > dropdown.scrollTop + dropdown.clientHeight) {
        dropdown.scrollTop = bottom - dropdown.clientHeight;
      }
    },

    syncValue(value) {
      if (!value) return;

      var selected = this.options.find(
        function (x) {
          return x[this.valueColumn] === value;
        }.bind(this)
      );

      if (selected) {
        this.selectedOption = selected;
        this.search = selected[this.labelColumn];
      }
    },

    isSelected(option) {
      return option[this.valueColumn] === this.value;
    },

    hideImage(event) {
      if (event && event.target) {
        event.target.style.display = "none";
      }
    },
  },
};
</script>

<style scoped>
.v-select {
  position: relative;
  width: 100%;
}

.v-select-input-wrapper {
  position: relative;
}

.has-selected-image {
  padding-left: 44px;
}

.selected-option-image {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 26px;
  height: 26px;
  transform: translateY(-50%);
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #d9dee7;
  background: #f8f9fa;
  pointer-events: none;
}

.select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  opacity: 0.6;
}

.v-select-dropdown {
  background: #fff;
  position: absolute;
  width: 100%;
  z-index: 20;
  max-height: 260px;
  overflow-y: auto;
  border-radius: 0 0 6px 6px;
}

/* ✅ Animation */
.fade-slide-enter-active {
  animation: fadeSlideIn 0.15s ease-out;
}
.fade-slide-leave-active {
  animation: fadeSlideOut 0.15s ease-out;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeSlideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-6px);
  }
}

/* ✅ Option */
.option-item {
  cursor: pointer;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 34px;
}

.option-image {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #d9dee7;
  background: #f8f9fa;
}

.option-label {
  min-width: 0;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
}

.option-item:hover,
.highlighted {
  background: #f0f3ff !important;
}

.selected-option {
  background: #e5e7eb;
  font-weight: bold;
}

/* ✅ Loader */
.loader {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-top-color: #0d6efd;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
